/* "How to use this page" banner at the top of every page (prototype pageGuide()).
 * Collapsible; dismissible per page (remembered in localStorage, best effort). */
import { useEffect, useState } from "react";
import { useI18n } from "../../i18n";
import { useOverlays } from "../../app/overlays";
import { Button, Icon, IconButton, Steps } from "../../ui";
import { GUIDES, guideKeyFor } from "./guides";
import "./help.css";

export const GUIDE_STORE = "starthr-guides";

export function loadHidden(): Record<string, number> {
  try { const v = JSON.parse(localStorage.getItem(GUIDE_STORE) || "{}"); return v && typeof v === "object" ? v : {}; } catch { return {}; }
}
function saveHidden(v: Record<string, number>) {
  try { localStorage.setItem(GUIDE_STORE, JSON.stringify(v)); } catch { /* storage blocked */ }
}

export default function PageGuide({ path }: { path: string }) {
  const { L } = useI18n();
  const ov = useOverlays();
  const k = guideKeyFor(path);
  const [hidden, setHidden] = useState<Record<string, number>>(loadHidden);
  const [open, setOpen] = useState(true);
  useEffect(() => { setOpen(true); }, [k]);
  if (!k) return null;
  const g = GUIDES[k];

  const hide = () => { const v = { ...hidden, [k]: 1 }; setHidden(v); saveHidden(v); };
  const show = () => { const v = { ...hidden }; delete v[k]; setHidden(v); saveHidden(v); setOpen(true); };

  if (hidden[k]) {
    return (
      <button type="button" className="guide-mini" onClick={show} data-testid="guide-show">
        <Icon name="info" className="s" />{L("How this page works", "كيف تعمل هذه الصفحة")}
      </button>
    );
  }
  const stepsId = "guide-steps-" + k;
  return (
    <section className="guide" aria-label={L("Page guide", "دليل الصفحة")} data-testid="page-guide" data-guide={k}>
      <div className="guide-h">
        <span className="guide-ic"><Icon name="info" /></span>
        <button type="button" className="guide-toggle" aria-expanded={open} aria-controls={stepsId} onClick={() => setOpen(!open)} data-testid="guide-toggle">
          <span className="guide-eyebrow">{L("How to use this page", "طريقة استخدام هذه الصفحة")}</span>
          <b>{L(g.t[0], g.t[1])}</b>
          <Icon name={open ? "chevron-up" : "chevron-down"} className="s" />
        </button>
        <span className="spacer" />
        <Button variant="ghost sm" icon="book" onClick={() => ov.open({ kind: "help", topic: k })} data-testid="guide-full">{L("Open full guide", "فتح الدليل الكامل")}</Button>
        <IconButton icon="x" label={L("Hide guide", "إخفاء الدليل")} onClick={hide} data-testid="guide-hide" />
      </div>
      {open && <div id={stepsId}><Steps vertical={false} steps={g.steps.map((s) => L(s[0], s[1]))} /></div>}
    </section>
  );
}
